const Enums = Object.freeze({
  endpoints: {
    auth: {
      LOGIN: "/auth/login",
      SIGNUP: "/auth/signup",
      LOGOUT: "/auth/logout",
      REFRESH: "/auth/refresh",
      ME: "/auth/me",
      ACTIVATE: "/auth/activate/[token]",
      FORGOT_PASSWORD: "/auth/forgot-password",
      RESET_PASSWORD: "/auth/reset-password/[token]",
      CHANGE_PASSWORD: "/auth/change-password",
    },
    store: {
      ALL: "/store/all",
      AGGR: "/store/aggregate",
      WOO: "/store/woo",
      DETAIL: "/store/[id]",
      WOO_AUTH: "/store/woo/auth",
      SEARCH: "/store/search",
    },
    orders: {
      ALL: "/orders",
    },
    stats: {
      STORES: "/stats/stores",
      STORES_ORDER_COUNT: "/stats/storesByOrderCount",
      ORDER_COUNT_BY_DAY: "/stats/ordersReport",
    },
    tiktok: {
      AUTH_TOKEN: "/tiktok/auth/token/[id]",
      CREATE_LABLE: "/tiktok/fulfillment",
      CREATE_FLASH_SALE: "/tiktok/promotion/createFlashDeal",
    },
    google: {
      oauth2: "/google/oauth2",
      oauth2Callback: "/google/oauth2/callback",
      oauth2Refresh: "/google/oauth2/refresh",
    },
    options: {
      SAVE: "/options",
      LIST: "/options",
      DELETE: "/options/[id]",
    },
    media: {
      IMG: "/media/image",
    },
    paypal: {
      ACCOUNT: "/gateway/paypal/account",
      ACCOUNT_PR: "/gateway/paypal/account/[id]",
      ACCOUNT_TEST: "/gateway/paypal/account/[id]/test",
      EXPORT_PAYMENTS_INIT: "/gateway/paypal/tools/export-payments/init",
      EXPORT_PAYMENTS_CHUNK: "/gateway/paypal/tools/export-payments/chunk",
      EXPORT_DISPUTES_INIT: "/gateway/paypal/tools/export-disputes/init",
      EXPORT_DISPUTES_CHUNK: "/gateway/paypal/tools/export-disputes/chunk",
      EXPORT_REFUNDS_INIT: "/gateway/paypal/tools/export-refunds/init",
      EXPORT_REFUNDS_CHUNK: "/gateway/paypal/tools/export-refunds/chunk",
      EXPORT_TRACKING_INIT: "/gateway/paypal/tools/export-tracking/init",
      EXPORT_TRACKING_CHUNK: "/gateway/paypal/tools/export-tracking/chunk",
      ADD_TRACKING_INIT: "/gateway/paypal/tools/add-tracking/init",
      ADD_TRACKING_CHUNK: "/gateway/paypal/tools/add-tracking/chunk",
    },
    workspace: {
      ALL: "/workspace",
      DETAIL: "/workspace/[id]",
      MEMBER: "/workspace/member",
    },
    ext: {
      API_TOKEN: "/integration/token",
    },
    apiKeys: {
      LIST: "/api-keys",
      CREATE: "/api-keys",
      REVOKE: "/api-keys/[id]/revoke",
      DELETE: "/api-keys/[id]",
    },
    mailtemplate: {
      ALL: "/mailtemplate",
    },
    supplierStock: {
      SUPPLIERS: "/supplier-stock/suppliers",
      PRODUCTS: "/supplier-stock/products",
      SHEET_NAMES: "/supplier-stock/sheets/names",
      SHEET_EXPORT_STOCK: "/supplier-stock/sheets/export-stock",
      SHEET_SYNC_STOCK: "/supplier-stock/sheets/sync-stock",
    },
    toolSupport: {
      SHEET_DATA: "/tool-support/sheets/data",
      VALIDATE_INIT: "/tool-support/fulfillment/validate-address/init",
      VALIDATE_BATCH: "/tool-support/fulfillment/validate-address/batch",
      VALIDATE_WRITE: "/tool-support/fulfillment/validate-address/write",
      EXPORT_ORDERS: "/tool-support/orders/export",
      EXPORT_ORDERS_PAGE: "/tool-support/orders/export-page",
    },
  },
  Regex: {
    NAME: /^[a-zA-Z][a-zA-Z0-9 ]{2,23}$/,
    EMAIL: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
    PASS: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%]).{6,24}$/,
  },
});

export default Enums;
